import { createFileRoute } from '@tanstack/react-router';
import { Mail } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { ChangeEmailForm } from '@/components/features/user/forms/change-email-form';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { TabsContent } from '@/components/ui/tabs';

export const Route = createFileRoute('/_authenticated/user/edit/account')({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();

  return (
    <TabsContent value="account">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center">
            <Mail className="mr-2 h-5 w-5 text-blue-500" />
            {t('authenticated.user.edit.account.title')}
          </CardTitle>
          <CardDescription>
            {t('authenticated.user.edit.account.description')}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ChangeEmailForm onSubmit={console.log} isSubmitting={false} />
        </CardContent>
      </Card>
    </TabsContent>
  );
}
